export const isDisabled = state => state.fetching
export const isFetching = state => state.fetching
